<template>
  <div class="rivals-list">
    <b-card no-body>
      <LoadingIndicator v-if="loading" centered />
      <div v-if="!loading">
        <table v-if="relatedLoads.length > 0" class="table">
          <thead>
            <tr>
              <th>Order ID</th>
              <th>Status</th>
              <th>Origin</th>
              <th>Destination</th>
              <th>Vehicle</th>
              <th>Move date</th>
              <th>Carrier Pay</th>
              <th>Carrier</th>
              <th>Dispatched at</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in relatedLoads" :key="item.id">
              <td>
                <router-link :to="{ name: 'OrderDetails', params: { id: item.id } }">#{{ item.id }}</router-link>
              </td>
              <td>{{ item.leadStatus ? item.leadStatus.title : '' }}</td>
              <td>{{ item.pickupLocation.city }}, {{ item.pickupLocation.state }} {{ item.pickupLocation.zip }}</td>
              <td style="width: 130px">{{ item.deliveryLocation.city }}, {{ item.deliveryLocation.state }} {{ item.deliveryLocation.zip }}</td>
              <td style="width: 160px">
                <div v-for="vehicle in item.vehicles" :key="vehicle.id">{{ vehicle.year }} {{ vehicle.make }} {{ vehicle.model }}</div>
              </td>
              <td style="width: 95px"> {{ item.pickupDate || item.move_date || '' }}</td>
           
              <td style="width: 100px">
                <span v-if="item.carrierPay">${{ item.carrierPay }}</span>
              </td>
              <td>
                <router-link v-if="item.carrier" :to="{ name: 'CarrierDetails', params: { id: item.carrier.id } }">{{ item.carrier.contact.company }}</router-link>
              </td>
              <td style="width: 220px">{{ item.signedAt | formatDateTime}}</td>
            </tr>
          </tbody>
        </table>
        <div v-else class="alert alert-info">No related loads has been found yet.</div>
      </div>
    </b-card>
  </div>
</template>

<script>
import { ApiClient } from '@/api/ApiClient';
import LoadingIndicator from '@/components/shared/LoadingIndicator';

export default {
  props: {
    leadlikeId: {
      type: [Number, String],
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    LoadingIndicator,
  },
  data() {
    return {
      relatedLoads: [],
      loading: false,
    };
  },
  computed: {
    fetchParams() {
      return {};
    },
  },
  methods: {
    async fetch() {
      if (this.loading) return;
      this.loading = true;
      const response = await ApiClient.leads.relatedLoads.get({
        leadId: this.leadlikeId,
        params: this.fetchParams
      });
      this.loading = false;
      if (response.status === 200) {
        this.relatedLoads = response.data.data;
      }
    },
  },
  created() {
    this.fetch();
  },
  watch: {
    leadlikeId: function () {
      this.fetch();
    },
  },
};
</script>
